<template>
    <fragment>
        <InsideHeader title="QR Code" :bredcrumb="breadcrumb" />
        <section class="login-page-area">
            <div class="bubble-box">
                <div class="bubbles-1"></div>
                <div class="bubbles-2"></div>
                <div class="bubbles-3"></div>
                <div class="bubbles-4"></div>
                <div class="bubbles-5"></div>
                <div class="bubbles-7"></div>
            </div>

            <div class="container">
                <div class="row login-wrapper">
                    <!-- Login Area Start-->
                    <div class="col-6col-12 col-sm-12 col-md-6 login-form-1">
                        <h3>Generate Your QR Code</h3>
                    
                        <form id="contact-form" method="post" @submit.prevent="uploadMenu">
                            <span class="input input--nao">
                                <input class="input__field input__field--nao" type="text" v-model.trim="$v.formData.name.$model" placeholder="Full Name"/>
                                <svg class="graphic graphic--nao" :class="(!formStatus && $v.formData.name.$error) ? 'error-stroke' : ''" width="300%" height="100%" viewBox="0 0 1200 60" preserveAspectRatio="none">
                                    <path d="M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0"/>
                                </svg>
                            </span>
                            <p class="form-error" v-if="!formStatus && $v.formData.name.$error && !$v.formData.name.required">Please Enter your name!</p>
                            <!-- <p class="form-error" v-if="!formStatus && $v.formData.name.$error && !$v.formData.name.alpha">Please Enter valid name!</p> -->
                            <p class="form-error" v-if="!formStatus && $v.formData.name.$error && !$v.formData.name.minLength">Name must have at least {{$v.formData.name.$params.minLength.min}} letters.!</p>

                            <span class="input input--nao">
                                <input class="input__field input__field--nao" type="email" v-model.trim="$v.formData.email.$model" placeholder="Email"/>
                                <svg class="graphic graphic--nao" :class="(!formStatus && $v.formData.email.$error) ? 'error-stroke' : ''" width="300%" height="100%" viewBox="0 0 1200 60" preserveAspectRatio="none">
                                    <path d="M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0"/>
                                </svg>
                            </span>
                            <p class="form-error" v-if="!formStatus && $v.formData.email.$error && !$v.formData.email.required">Please Enter your email!</p>
                            <p class="form-error" v-if="!formStatus && $v.formData.email.$error && !$v.formData.email.email">Invalid Email Address!</p>

                            <span class="input input--nao">
                                <input class="input__field input__field--nao" type="tel" v-model.trim="$v.formData.phone.$model" placeholder="Phone"/>
                                <svg class="graphic graphic--nao" :class="(!formStatus && $v.formData.phone.$error) ? 'error-stroke' : ''" width="300%" height="100%" viewBox="0 0 1200 60" preserveAspectRatio="none">
                                    <path d="M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0"/>
                                </svg>
                            </span>
                            <p class="form-error" v-if="!formStatus && $v.formData.phone.$error && !$v.formData.phone.required">Please Enter your phone Number!</p>
                            <p class="form-error" v-if="!formStatus && $v.formData.phone.$error && !$v.formData.phone.numeric">Invalid Phone Number!</p>

                            <span class="input input--nao">
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" class="custom-control-input" name="type" id="link" value="link" checked v-model="formData.type">
                                    <label class="custom-control-label" for="link">Upload Link</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" class="custom-control-input" value="pdf" id="pdf" name="type" v-model="formData.type">
                                    <label class="custom-control-label" for="pdf">Upload PDF</label>
                                </div>
                            </span>
                            
                            <span class="input input--nao" v-if="formData.type === 'link'">
                                <input class="input__field input__field--nao" type="url"  v-model.trim="$v.formData.link.$model" placeholder="Add Link"/>
                                <svg class="graphic graphic--nao" :class="(!formStatus && $v.formData.link.$error) ? 'error-stroke' : ''" width="300%" height="100%" viewBox="0 0 1200 60" preserveAspectRatio="none">
                                    <path d="M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0"/>
                                </svg>
                            </span>
                            <p class="form-error" v-if="!formStatus && formData.type === 'link' && $v.formData.link.$error && !$v.formData.link.required">Please Enter the link!</p>
                            <p class="form-error" v-if="!formStatus && formData.type === 'link' && $v.formData.link.$error && !$v.formData.link.url">Invalid Link!</p>

                            <span class="input input--nao" v-if="formData.type === 'pdf'">
                                <input class="input__field input__field--nao" type="file" ref="file" @change="selectFile" accept=".pdf,.docx,.doc,.ppt,.pptx"/>
                                <small>(Format: .pdf, .doc, .docx, .ppt, .pptx. Max file size 50MB)</small>
                            </span>
                            <p class="form-error" v-if="file_error">{{ file_error }}</p>


                            <!--message-area-->
                            <div class="d-flex message-button-wrap">
                                <div class="subm-btn theme-button">
                                    <input type="submit" class="btn contact-btn" value="Submit">
                                </div>
                            </div>
                            <div class="resMsg text-center" v-html="formResponse"></div>
                        </form>
                    </div>
                    
                    <!-- Login Area End-->
                </div>
            </div>
        </section>
    </fragment>
</template>


<script>
import { required, minLength, email, alpha, numeric, url } from 'vuelidate/lib/validators'
// import { required, minLength, email, alpha, numeric } from 'vuelidate/lib/validators'
import InsideHeader from "../components/InsideHeader.vue";

export default {
    components: {
        InsideHeader
    },
    data() {
        return {
            formData: {
                name: '',
                email: '',
                phone:'',
                type: 'link',
                link: null
            },
            file_error: '',
            buttonStatus: 'disabled',
            selectedFiles: '',
            formResponse: '',
            formStatus: true,
            breadcrumb: [
                {title: 'Home', path:'/'},
                {title: 'QR Code', path:'#'}
            ]
        }
    },
    validations: function(){
        if(this.formData.type === 'link') {
            return {
                formData: {
                    name: {
                        required,
                        minLength: minLength(4)
                    },
                    email: {required,email},
                    phone: {required, numeric},    
                    link: {required, url}  
                }
            }
        }
        else {
            return {
                formData: {
                    name: {
                        required,
                        alpha,
                        minLength: minLength(4)
                    },
                    email: {required,email},
                    phone: {required, numeric} 
                }
            }
        }
    },
    methods: {
        selectFile() {
            let file = this.$refs.file.files;
            if(!file.length){
                this.selectedFiles = ''
                return;
            }
            if(file.item(0).size <= 50000000) {
                this.selectedFiles = file
                this.file_error = ''
                document.querySelector('input[type=submit]').removeAttribute('disabled')
            }
            else {
                document.querySelector('input[type=submit]').setAttribute('disabled', true)
                this.selectedFiles = ''
                this.file_error =`File is too large!`
            }
            if(
                file.item(0).type !== 'application/pdf' && 
                file.item(0).type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' &&
                file.item(0).type !== 'application/vnd.openxmlformats-officedocument.presentationml.presentation' &&
                file.item(0).type !== 'application/msword' &&
                file.item(0).type !== 'application/vnd.ms-powerpoint'
            ) {
                this.selectedFiles = ''
                this.file_error =`Invalid file format!`
                document.querySelector('input[type=submit]').setAttribute('disabled', true)
            }
            else {
                this.selectedFiles = file
                this.file_error = ''
                document.querySelector('input[type=submit]').removeAttribute('disabled')
            }
        },
        uploadMenu(){
            this.$v.$touch()
            this.formStatus = false
            if(!this.$v.$invalid){
                let formData = new FormData()
                formData.append("name", this.formData.name);
                formData.append("email", this.formData.email);
                formData.append("phone", this.formData.phone);
                formData.append("type", this.formData.type);

                if(this.formData.type === 'link')
                    formData.append("link", this.formData.link);

                if(!this.selectedFiles && this.formData.type === 'pdf'){
                    this.file_error =`Please upload file!`
                    return;
                }
                if(this.formData.type === 'pdf' && this.selectedFiles.item(0)) {
                    formData.append("file_name", this.selectedFiles.item(0));
                }

                document.querySelector('.resMsg').style.display = 'block'
                this.$http.post(`/upload-menu`, formData,  {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(res=>{
                    if(typeof res !== 'undefined' && res.status === 200){
                         if(res.data.status === true){
                            this.resetForm()
                            this.formResponse =`<p class="alert alert-success">${res.data.message}</p>` 
                            this.formStatus = true   
                         }                
                        else
                            this.formResponse =`<p class="alert alert-danger">${res.data.error}</p>`
                    }
                    
                }).catch(err => {
                    console.log(err.response);
                    this.formResponse =`<p class="alert alert-danger">${err.response.data.error}</p>`;
                })

                this.togellingResponse();
            }
        },
        togellingResponse(){
            setTimeout(()=>{
                document.querySelector('.resMsg').style.display = 'none'
                this.formResponse = ''
            }, 5000)
        },
        resetForm(){
            Object.keys(this.formData).forEach(item=>{
                this.formData[item] = ''
            })    
        }
    }
}
</script>

<style scoped>
.form-error{
    color: #f00; font-size: 0.7rem;
}
.input__field{height:50px;}
.error-stroke{stroke:#f00;}
.login-wrapper .input--nao {
    margin-bottom: 0;
    padding: 10px 0;
}
</style>